/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Image_Export_Status_Export_FailedInputs */

const en_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Export failed: ${i?.error}`)
};

const fr_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'exportation : ${i?.error}`)
};

const de_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Export fehlgeschlagen: ${i?.error}`)
};

const it_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione non riuscita: ${i?.error}`)
};

const ru_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт не удался: ${i?.error}`)
};

const es_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportación fallida: ${i?.error}`)
};

const zh_cn2_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出失败：${i?.error}`)
};

const ja_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エクスポートに失敗しました: ${i?.error}`)
};

const hi_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`निर्यात विफल: ${i?.error}`)
};

const pt_pt2_image_export_status_export_failed = /** @type {(inputs: Image_Export_Status_Export_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportação falhou: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Export failed: {error}" |
*
* @param {Image_Export_Status_Export_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_status_export_failed = /** @type {((inputs: Image_Export_Status_Export_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Status_Export_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_status_export_failed(inputs)
	if (locale === "de") return de_image_export_status_export_failed(inputs)
	if (locale === "it") return it_image_export_status_export_failed(inputs)
	if (locale === "ru") return ru_image_export_status_export_failed(inputs)
	if (locale === "es") return es_image_export_status_export_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_status_export_failed(inputs)
	if (locale === "ja") return ja_image_export_status_export_failed(inputs)
	if (locale === "hi") return hi_image_export_status_export_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_status_export_failed(inputs)
	return en_image_export_status_export_failed(inputs)
});